import { state } from "../context/store";
import { useSnapshot } from "valtio";

const setPage = (index) => {
  state.current.currentStep = index;
};

const incrementPage = (index, max) => {
  // if (index + 1 < max) {
  state.current.currentStep = index + 1;
  // }
};

const decrementPage = (current) => {
  if (current > 0) {
    state.current.currentStep = current - 1;
  }
};

export { setPage, incrementPage, decrementPage };
